import { FC, useCallback, useRef } from 'react';

import { GeoSuggestItemType, IGeoSuggestItem } from 'shared/types/geoSuggest';
import GeoSuggest from '../../../../../GeoSuggest';
import { ILocation } from 'shared/types/location';

export interface ILocationSwitcherAutocompleteProps {
  suggestions?: ILocation[];
  loading: boolean;
  onValueChange(value: string): void;
  onSelect(suggestion: IGeoSuggestItem<ILocation>): void;
}

export const LocationSwitcherAutocomplete: FC<ILocationSwitcherAutocompleteProps> = props => {
  const { onSelect } = props;

  const suggestRef = useRef<GeoSuggest>(null);

  const handleSelect = useCallback(
    (suggestion: IGeoSuggestItem<ILocation>) => {
      if (suggestRef.current) {
        suggestRef.current.reset();
      }

      onSelect(suggestion);
    },
    [onSelect],
  );

  return (
    <div style={{ width: '360px' }}>
      <GeoSuggest
        {...props}
        ref={suggestRef}
        onSelect={handleSelect}
        placeholder="Введите регион или город"
        suggestions={
          props.suggestions &&
          props.suggestions.map(suggestion => ({
            title: suggestion.displayName || '',
            value: suggestion,
            suggestionType: GeoSuggestItemType.Address,
          }))
        }
      />
    </div>
  );
};
